"use strict";

require("@cbhq/cds-fonts/fonts.css");
require("@cbhq/cds-icons/fonts/web/icon-font.css");
require("./styles/global");